import { DocumentNode } from 'apollo-link';

import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceQuery($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
